import React, { useState, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalBody } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle, faSave, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { ResponseSuccessModal, ResponseFailModal } from '../../modal/Response';
import Spin from '../../Spin';
import * as api from '../../../api';

const StaffkeyDelete = ({
  isOpen,
  toggle,
  reload,
  keyId,
}) => {
  const { t } = useTranslation();
  const [ isLoading, setIsLoading ] = useState(false);
  const [ isOpenStaffkeyDeleteSuccessModal, setIsOpenStaffkeyDeleteSuccessModal ] = useState(false);
  const [ isOpenStaffkeyDeleteFailModal, setIsOpenStaffkeyDeleteFailModal ] = useState(false);
  const [ messageStaffkeyIssueFail, setMessageStaffkeyIssueFail ] = useState('');

  const deleteStaffkey = async () => {
    try {
      setIsLoading(true);
      await api.deleteStaffMobilekey({keyId});
      toggle();
      setIsOpenStaffkeyDeleteSuccessModal(true);
      setTimeout(() => {
        setIsOpenStaffkeyDeleteSuccessModal(false);
        reload();
      }, 1500);
    } catch (error) {
      if (!error.response) setMessageStaffkeyIssueFail(error.message);
      else setMessageStaffkeyIssueFail(`${error.response.data.code}, ${error.response.data.message}`);
      setIsOpenStaffkeyDeleteFailModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Fragment>
      <Modal
        show={isOpen}
        onHide={() => toggle()}
        centered
        size='sm'
      >
        <Spin isSpin={isLoading} isModal={true}/>
        <ModalBody className='text-center m-3'>
          <FontAwesomeIcon icon={faQuestionCircle} style={{fontSize:'5em', color:'orange'}}/>
          <p className='mb-0 mt-4' style={{fontSize:'15px'}}>
            {t('confirm_message.delete_staffkey')}
          </p>
          <button className='modal-btn-cancel' onClick={() => toggle()}>
            <FontAwesomeIcon icon={faTimesCircle} style={{paddingRight:'3px'}}/>{t('button.cancel')}
          </button>
          <button className='modal-btn-confirm' onClick={deleteStaffkey}>
            <FontAwesomeIcon icon={faSave} style={{paddingRight:'3px'}}/>{t('button.ok')}
          </button>
        </ModalBody>
      </Modal>
      <ResponseSuccessModal
        isOpen={isOpenStaffkeyDeleteSuccessModal}
        toggle={() => setIsOpenStaffkeyDeleteSuccessModal(!isOpenStaffkeyDeleteSuccessModal)}
        message={t('success_message.delete_staffkey')}
      />
      <ResponseFailModal
        isOpen={isOpenStaffkeyDeleteFailModal}
        toggle={() => setIsOpenStaffkeyDeleteFailModal(!isOpenStaffkeyDeleteFailModal)}
        message={messageStaffkeyIssueFail || t('error_message.delete_staffkey')}
      />
    </Fragment>
  );
}

export default StaffkeyDelete;